import React, { Component } from 'react';
import { authentication } from '../services/Authentication';
import $ from "jquery";

export default class Login extends Component {

    constructor(props) {
        super(props);

        if (authentication.currentUserValue) {
            this.props.history.push('/');
        }

        this.state = {
            username: '',
            password: ''
        }

        $("body").addClass("login-page");
        $("#root").removeClass("wrapper");

        this.change = this.change.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);

    }

    change(e) {
        this.setState({
            [e.target.name]: e.target.value
        });
    }

    handleSubmit(event) {
        event.preventDefault();
        if (this.state.username === "") {
            alert("ไม่พบข้อมูลผู้ใช้");
            return;
        }
        if (this.state.password === "") {
            alert("ไม่พบรหัสพนักงาน");
            return;
        }
        //alert(this.state.username);
        authentication.login(this.state.username, this.state.password)
            .then(data => {
                if (data.status === "Success") {
                    const { from } = this.props.location.state || { from: { pathname: "/" } };
                    this.props.history.push(from);
                } else {
                    alert(data.message);
                    return;
                    console.log(data.message);
                }

            },
                error => {
                    console.log(error);
                }
            )
    }

    render() {
        return (
            <div className="login-box">
                {/* <div className="login-logo">
                    <b>Admin</b> Nirvana
                </div> */}
                {/* /.login-logo */}
                <div className="card">
                    <div className="card-body login-card-body">
                        <p className="login-box-msg">เข้าสู่ระบบ <b>Admin</b></p>
                        <form method="post" onSubmit={this.handleSubmit}>
                            <div className="input-group mb-3">
                                <input type="text" className="form-control" placeholder="ชื่อผู้ใช้" name="username" onChange={this.change} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-envelope" />
                                    </div>
                                </div>
                            </div>
                            <div className="input-group mb-3">
                                <input type="password" className="form-control" placeholder="รหัสผ่าน" name="password" onChange={this.change} />
                                <div className="input-group-append">
                                    <div className="input-group-text">
                                        <span className="fas fa-lock" />
                                    </div>
                                </div>
                            </div>
                            <div className="row">
                                {/* <div className="col-8">
                                    <div className="icheck-primary">
                                        <input type="checkbox" id="remember" />
                                        <label htmlFor="remember">
                                            จำรหัสผ่าน
                                        </label>
                                    </div>
                                </div> */}
                                {/* /.col */}
                                <div className="col-md-4">
                                </div>
                                <div className="col-md-4">
                                    <button type="submit" className="btn btn-login">เข้าสู่ระบบ</button>
                                </div>
                                <div className="col-md-4">
                                </div>
                                {/* /.col */}
                            </div>
                        </form>
                        {/* /.social-auth-links */}
                        {/* <p className="mb-1">
                            <a href="#/">ลืมรหัสผ่าน</a>
                        </p> */}
                    </div>
                    {/* /.login-card-body */}
                </div>
            </div>
        );
    }
};